angular.module 'zc.commonApi'

.factory "AccessStats", ($q, FacadeV2) ->

  class AccessStats
    @handleCampaignDevice: (campaign_device) ->
      switch campaign_device
        when 'pc' then {$in: ['pc', 'tablet']}
        when 'sp', 'iphone' then 'sp'
        when 'devicefree' then {$in: ['pc', 'tablet', 'sp']}
        else
          null

    @fields: [
      'session_count'
      'history_count'
      'interest_count'
      'conversion_count'
      'conversion_price'
      'cart_button_click_count'
      'referrer_count'
      'dwell'
      'repeat_session_count'
      'mobile_session_count'
      'tablet_session_count'
      'pc_session_count'
      'other_device_session_count'
    ]

    @aggregate: (paths, query) ->
      params = {}
      params.match = query.match
      params.pipeline = query.pipeline

      FacadeV2.request "/apikeys/#{paths.apikey}/access_stats/#{paths.dimension}/aggregate", {
        params: params
      }
      .then (res) ->
        res.data

    @aggregateDefault: (paths, match) ->
      query =
        match: match
      query.pipeline = []

      group =
        total_found:
          $sum: 1
      if paths.dimension in ['hour_of_day', 'day_of_week']
        group._id = {}
        group._id[paths.dimension] = "$#{paths.dimension}"
      else
        group._id = null

      for field in @fields
        group[field] =
          $sum: "$#{field}"
      query.pipeline.push
        $group: group

      query.pipeline.push
        $sort:
          _id: 1

      project =
        total_found: 1
      if paths.dimension in ['hour_of_day', 'day_of_week']
        project[paths.dimension] = "$_id.#{paths.dimension}"

      for field in @fields
        project[field] = 1
      query.pipeline.push
        $project: project

      paths = _.assignIn {}, paths
      paths.dimension = 'hourly' if paths.dimension == 'hour_of_day'
      paths.dimension = 'daily' if paths.dimension == 'day_of_week'

      @aggregate paths, query
      .then (data) =>
        if data.length
          data = @transformResults data
        else
          dummy =
            total_found: 0
          for field in @fields
            data[field] = 0
          data = [dummy]
        data

    @aggregateByFilter: (paths, filters) ->
      match = filtersToMatch filters
      @aggregateDefault(paths, match)

    @find: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/access_stats/#{paths.dimension}/find", {
        params: params
      }
      .then (res) ->
        res.data

    @findDefault: (paths, match) ->
      query = {
        match
        limit: 10000
        fields: @fields.concat('end_at').concat(_.keys(match))
      }

      @find(paths, query)
      .then (data) =>
        if data.length
          # combine the counts per day because there might be results for
          # multiple devices per day (PC+tablet)
          sumByStartAt = {}
          for doc in data
            sumByStartAt[doc.start_at] ||= {}
            sumByStartAt[doc.start_at]['start_at'] ||= doc['start_at']
            sumByStartAt[doc.start_at]['end_at'] ||= doc['end_at']
            for field in @fields
              sumByStartAt[doc.start_at][field] ||= 0
              sumByStartAt[doc.start_at][field] += doc[field]
          data = _.values sumByStartAt
          data = @transformResults data
        else
          data = []
        data

    @findByFilter: (paths, filters) ->
      match = filtersToMatch filters
      @findDefault(paths, match)

    filtersToMatch = (filters)->
      {
        device: emptyToNull(filters.device)
        campaign_segment_id: emptyToNull(filters.campaign_segment)
        is_control: emptyToNull(filters.is_control)
        start_at:
          $gte: moment(filters.start_at).toDate()
          $lt: moment(filters.end_at).toDate()
      }

    emptyToNull = (val)->
      if val == ''
        null
      else
        val

    @transformResults = (access_stats) ->
      for stats in access_stats
        if stats.session_count
          stats.conversion_rate = stats.conversion_count / stats.session_count
          stats.cart_button_click_rate = stats.cart_button_click_count / stats.session_count
          stats.average_dwell = stats.dwell / stats.session_count
          stats.average_history_count = stats.history_count / stats.session_count
          stats.average_interest_count = stats.interest_count / stats.session_count
          stats.mobile_session_rate = stats.mobile_session_count / stats.session_count
          stats.repeat_session_rate = stats.repeat_session_count / stats.session_count
        else
          stats.conversion_rate = 0
          stats.cart_button_click_rate = 0
          stats.average_dwell = 0
          stats.average_history_count = 0
          stats.average_interest_count = 0
          stats.mobile_session_rate = 0
          stats.repeat_session_rate = 0
        if stats.conversion_count
          stats.average_conversion_price = stats.conversion_price / stats.conversion_count
        else
          stats.average_conversion_price = 0
        stats.start_at = new Date(stats.start_at).valueOf() if stats.start_at
        stats.end_at = new Date(stats.end_at).valueOf() if stats.end_at
      access_stats

  AccessStats



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/access_stats_service.js.coffee